import axios from '@/libs/api.request'

const userBaseUrl = '/api/v1/'

export const login = ({ userName, password }) => {
  const data = {
    'username': userName,
    'password': password
  }
  return axios.request({
    url: userBaseUrl + 'api-token-auth/',
    data,
    method: 'post'
  })
}

export const refreshToken = (data) => {
  return axios.request({
    url: userBaseUrl + 'api-token-refresh/',
    data,
    method: 'post'
  })
}

export const getUserInfo = (userId) => {
  return axios.request({
    url: userBaseUrl + 'current_user_info/' + userId + '/',
    method: 'get'
  })
}

export const logout = (token) => {
  return axios.request({
    url: 'logout',
    method: 'post'
  })
}

export const GetUsers = (params) => {
  return axios.request({
    url: userBaseUrl + 'user/',
    params: params,
    method: 'get'
  })
}

export const GetALLUsers = (params) => {
  return axios.request({
    url: userBaseUrl + 'all_user_list/',
    params: params,
    method: 'get'
  })
}

export const ChangeUsers = (data, id) => {
  let url = userBaseUrl + 'user/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

export const DeleteUsers = (id) => {
  return axios.request({
    url: userBaseUrl + 'user/' + id + '/',
    method: 'delete'
  })
}

// 取所有分组
export const getAllGroup = () => {
  return axios.request({
    url: userBaseUrl + 'all_group_list/',
    method: 'get'
  })
}

export const getAllPermission = () => {
  return axios.request({
    url: userBaseUrl + 'permission/',
    method: 'get'
  })
}

// 取分组列表（带分页）
export const getGroups = (params) => {
  return axios.request({
    url: userBaseUrl + 'group_list/',
    params: params,
    method: 'get'
  })
}

// 编辑用户组信息
export const changeGroup = (data, id) => {
  let url = userBaseUrl + 'group/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

// 删除用户组
export const deleteGroup = (id) => {
  return axios.request({
    url: userBaseUrl + 'group/' + id + '/',
    method: 'delete'
  })
}

// 获取角色列表（分页）
export const getRoles = (params) => {
  return axios.request({
    url: userBaseUrl + 'role_list/',
    params: params,
    method: 'get'
  })
}

// 获取角色关联的数据对象权限（分页）
export const getObjectPermList = (params) => {
  return axios.request({
    url: userBaseUrl + 'object_perm/',
    params: params,
    method: 'get'
  })
}

// 删除角色关联的数据对象权限
export const deleteDataPerm = (id) => {
  return axios.request({
    url: userBaseUrl + 'object_perm/' + id + '/',
    method: 'delete'
  })
}

// 获取全部角色列表（不分页）
export const getAllRoles = () => {
  return axios.request({
    url: userBaseUrl + 'all_role_list/',
    method: 'get'
  })
}

// 编辑保存角色信息
export const changeRole = (data, id) => {
  let url = userBaseUrl + 'role/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

// 编辑保存角色信息
export const updateRole = (data, id) => {
  return axios.request({
    url: userBaseUrl + 'role/' + id + '/',
    data: data,
    method: 'patch'
  })
}

// 删除角色
export const deleteRole = (id) => {
  return axios.request({
    url: userBaseUrl + 'role/' + id + '/',
    method: 'delete'
  })
}

export const resetPassword = (data, id) => {
  return axios.request({
    url: userBaseUrl + 'password/reset/' + id + '/',
    data: data,
    method: 'put'
  })
}

export const getMenu = (params) => {
  return axios.request({
    url: userBaseUrl + 'menu_list/',
    params: params,
    method: 'get'
  })
}

export const createMenu = (params) => {
  return axios.request({
    url: userBaseUrl + 'menu/',
    data: params,
    method: 'post'
  })
}

export const deleteMenu = (pk) => {
  return axios.request({
    url: userBaseUrl + 'menu/' + pk + '/',
    method: 'delete'
  })
}

export const updateMenu = (params, pk) => {
  return axios.request({
    url: userBaseUrl + 'menu/' + pk + '/',
    data: params,
    method: 'put'
  })
}

// 取所有ContentType
export const getAllContentType = () => {
  return axios.request({
    url: userBaseUrl + 'all_content_type_list/',
    method: 'get'
  })
}

// 用户激活
export const userActiveApi = (data) => {
  return axios.request({
    url: userBaseUrl + 'user_active/',
    method: 'post',
    data: data
  })
}

// 所有租户列表
export const getAllTenants = (params) => {
  return axios.request({
    url: userBaseUrl + 'all_tenant_list/',
    params: params,
    method: 'get'
  })
}

// 取租户列表（带分页）
export const getTenants = (params) => {
  return axios.request({
    url: userBaseUrl + 'tenant_list/',
    params: params,
    method: 'get'
  })
}

// 租户详情
export const detailTenants = (id) => {
  return axios.request({
    url: userBaseUrl + 'tenant_list/' + id + '/',
    method: 'get'
  })
}

// 编辑租户信息
export const changeTenant = (data, id) => {
  let url = userBaseUrl + 'tenant/'
  let method = 'post'
  if (id) {
    url += id + '/'
    method = 'put'
  }
  return axios.request({
    url: url,
    data: data,
    method: method
  })
}

// 删除租户
export const deleteTenant = (id) => {
  return axios.request({
    url: userBaseUrl + 'tenant/' + id + '/',
    method: 'delete'
  })
}

// cas 单点登录
export const checkCas = (params) => {
  return axios.request({
    url: userBaseUrl + 'cas_login/',
    params: params,
    method: 'get'
  })
}

// cas 单点退出
export const casLogout = (params) => {
  return axios.request({
    url: userBaseUrl + 'cas_logout/',
    params: params,
    method: 'get'
  })
}

// token 有效检测
export const tokenCheck = (params) => {
  return axios.request({
    url: userBaseUrl + 'token_check/',
    params: params,
    method: 'get'
  })
}

// 代登录
export const substituteLoginApi = (data) => {
  return axios.request({
    url: userBaseUrl + 'substitute_login/',
    data: data,
    method: 'post'
  })
}

// 通过用户名查询用户信息
export const authByName = (data) => {
  return axios.request({
    url: userBaseUrl + 'auth_by_name/',
    data: data,
    method: 'post'
  })
}
